/**
 * LocalBusiness + MedicalBusiness JSON-LD for the Bring-A-Nurse homepage.
 * REPLACE the placeholder telephone / email / postalCode with real values
 * before shipping to production (or set them via env vars in a future pass).
 */
export const LOCAL_BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "MedicalBusiness"],
  "name": "Bring-A-Nurse Senior Companion PLLC",
  "alternateName": "Bring-A-Nurse",
  "description":
    "Compassionate, professional nurse companion services for seniors and their families in the Raleigh, NC area. A licensed nurse accompanies you to doctor visits and helps navigate healthcare.",
  "url": "https://www.bring-a-nurse-nc.com/",
  "image":
    "https://customer-assets.emergentagent.com/job_0aa6ae46-54a3-49aa-8f4a-e031b08b33ae/artifacts/e3e7suo1_image.png",
  "logo":
    "https://customer-assets.emergentagent.com/job_0aa6ae46-54a3-49aa-8f4a-e031b08b33ae/artifacts/e3e7suo1_image.png",
  "telephone": "+1-919-685-7293",
  "priceRange": "$$",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Fuquay Varina",
    "addressRegion": "NC",
    "postalCode": "27526",
    "addressCountry": "US",
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 35.5843,
    "longitude": -78.8,
  },
  "areaServed": [
    { "@type": "City", "name": "Fuquay Varina" },
    { "@type": "City", "name": "Holly Springs" },
    { "@type": "City", "name": "Apex" },
    { "@type": "City", "name": "Cary" },
    { "@type": "City", "name": "Raleigh" },
    { "@type": "AdministrativeArea", "name": "Wake County" },
  ],
  "serviceType": [
    "Senior nurse companion services",
    "Doctor appointment accompaniment for seniors",
    "Healthcare navigation and patient advocacy",
    "Medical appointment support for elderly",
  ],
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "08:00",
      "closes": "18:00",
    },
  ],
  "founder": {
    "@type": "Person",
    "name": "Nurse Gerri",
    "jobTitle": "Registered Nurse & Founder",
  },
};
